import { render, staticRenderFns } from "./Blackbook.vue?vue&type=template&id=6f965a4c&scoped=true"
import script from "./Blackbook.vue?vue&type=script&lang=js"
export * from "./Blackbook.vue?vue&type=script&lang=js"
import style0 from "./Blackbook.vue?vue&type=style&index=0&id=6f965a4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f965a4c",
  null
  
)

export default component.exports